import {
  Box, DateInput,
  FileInput,
  FormField, TextArea,
  TextInput,
  RadioButtonGroup,
} from "grommet";
import React, {
  ChangeEvent,
  ReactNode,
  useCallback,
  useState
} from "react";

export function FormElement({
  component: Component, required = false, label, help, error, rows, name, value, placeholder, onChange, onBlur, options, conditionalText,
}: {
  component: typeof FileInput |
  typeof TextInput |
  typeof TextArea |
  typeof DateInput | 
  typeof RadioButtonGroup;
  required?: boolean;
  label: string | ReactNode;
  help?: string | ReactNode;
  error?: string | false;
  rows?: number;
  name: string;
  value: any;
  placeholder?: string;
  options?: string[];
  onChange: ((event: ChangeEvent<HTMLInputElement>) => void) |
  ((event: ChangeEvent<HTMLTextAreaElement>) => void) |
  ((event: { value: string | string[]; }) => void) |
  ((event: undefined) => void);
  onBlur?: ((event: React.FocusEvent<HTMLInputElement>) => void);
  conditionalText?: ReactNode;
}) {
  const props: Record<string, any> = { onChange, onBlur };
  const [ blurred, setBlurred ] = useState(false);
  const setBlurTrue = useCallback(() => setBlurred(true), []);

  if (Component !== FileInput) {
    props.size = "small";
  }

  if (Component === TextArea) {
    props.rows = rows;
  }

  if (Component === RadioButtonGroup) {
    props.options = options;
  }

  return (
    <Box>
      <FormField
        required={required}
        label={<b>{label}</b>}
        onBlur={setBlurTrue}
        error={(blurred && error)}
        help={<small>
          <i>{help}</i>
        </small>}
      >
        <Component
          required={required}
          name={name}
          value={value || ""}
          placeholder={placeholder}
          {...props} />
          {conditionalText && (
          <Box margin={{ top: 'small' }}>
            {conditionalText}
          </Box>
        )}
      </FormField>
    </Box>
  );
}
